import { netsparkAxios } from 'core/services/HTTPService';
import { getUserGuideFilesUrl } from './apiUrls';
import { IGuideMenu } from './types';

export const getUserGuideFiles = () => (
  netsparkAxios.get<IGuideMenu[]>(getUserGuideFilesUrl())
);

export default getUserGuideFiles;
